import enterView from 'enter-view';

export const scrollHandler = {
    navScrollBreakPoint: 25,

    init($) {
        // check scrollposition on init
        this.checkNavScrollBreakpoint($);

        this.inViewAnimations($);
        $('body').addClass('in-view-initiated');

        $(window).on('scroll', () => {
            this.checkNavScrollBreakpoint($);
        });
    },

    checkNavScrollBreakpoint($) {
        if ($(window).scrollTop() > this.navScrollBreakPoint && !$('body').hasClass('scrolling')) {
            $('body').addClass('scrolling');
        } else if ($(window).scrollTop() <= this.navScrollBreakPoint && $('body').hasClass('scrolling')) {
            $('body').removeClass('scrolling');
        }
    },

    inViewAnimations($) {
        enterView({
            selector: '.content-block',
            enter: (el) => el.classList.add('in-view')
        });
    }
};
